// extracted by mini-css-extract-plugin
export default {"root":"ModalHeader_root__ULrxU","title":"ModalHeader_title__VzzUR","description":"ModalHeader_description__Tu5Rh"};